import { DataTable } from '../data-table/data-table';
import Logo from '../../assets/images/stratagenIcon.png';
import { useEffect, useState, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchBigQueryData } from '../../utils/fetchBigQuery';
import { QUERIES } from '../../constants/queries';
import { Button } from '../../components/ui/button';
import FileList from '../file-list/file-list';
import { FileInfo, fetchFiles } from '../../utils/fetchFiles';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';

export default function Page() {
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getAccessTokenSilently, logout } = useAuth0();
  const [view, setView] = useState('data');
  const fetchCalled = useRef(false);
  const [files, setFiles] = useState<FileInfo[]>([]);
  const [filesLoading, setFilesLoading] = useState(false);
  const [filesError, setFilesError] = useState('');
  const filesFetched = useRef(false);

  useEffect(() => {
    if (fetchCalled.current) return;
    fetchCalled.current = true;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const authToken = await getAccessTokenSilently();
        const fetchedData = await fetchBigQueryData(
          authToken,
          QUERIES.STUDY_QUERY
        );

        const processedData = fetchedData.map((item, index) => ({
          id: index + 1,
          ...item,
        }));

        setData(processedData);
      } catch (error) {
        console.error('Error during data fetching:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (view === 'files' && !filesFetched.current) {
      handleFetchFiles();
      filesFetched.current = true;
    }
  }, [view]);

  const handleFetchFiles = async () => {
    setFilesLoading(true);
    setFilesError('');
    try {
      const data = await fetchFiles();
      setFiles(data);
    } catch (error: any) {
      setFilesError(error.message || 'Failed to fetch files');
      setFiles([]);
    } finally {
      setFilesLoading(false);
    }
  };

  return (
    <div>
      <header className="flex sticky top-0 bg-background h-16 shrink-0 items-center gap-2 z-10 py-4 px-4 justify-between">
        <div className="flex items-center">
          <img src={Logo} alt="Company Logo" className="h-10 w-10 mr-2" />
          <h1 className="text-4xl font-medium text-[#201D46]">Stratagen</h1>
        </div>
        <div className="flex items-center gap-4">
          <Tabs
          value={view}
          onValueChange={(val) => setView(val as 'data' | 'files')}
          className="w-auto rounded-[10px]"
        >
          <TabsList>
            <TabsTrigger value="data" className="w-20">
              Data Table
            </TabsTrigger>
            <TabsTrigger value="files" className="w-20">
              Files
            </TabsTrigger>
          </TabsList>
        </Tabs>
          <Button className="rounded bg-[#1e1b3c]" onClick={() => logout()}>
            Log out
          </Button>
        </div>
      </header>
      <div className="@container/main flex flex-1 flex-col gap-2">
        <div className="flex flex-col gap-4 py-4">
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              &nbsp;&nbsp;Loading...
            </div>
          ) : view === 'data' ? (
            <DataTable data={data} />
          ) : (
            <FileList
              files={files}
              isLoading={filesLoading}
              error={filesError}
              onRefresh={handleFetchFiles}
            />
          )}
        </div>
      </div>
    </div>
  );
}
